"use strict";
window.theme = window.theme || {}
theme.CartDrawer = function() {
    function CartDrawer() {
        this.selector = {
            cartbubble: document.getElementById('cart-icon-bubble'),
            cartdrawer: document.getElementById('cart-drawer'),
            cartdraweroverlay: document.getElementById('cart-drawer-overlay'),
            cartdrawerclose: document.getElementById('cart-drawer-close'),
            formcartdrawer: document.getElementById('form-cart-drawer'),
            cartdraweritemcount: document.getElementById('cart-drawer-item-count'),
            cartcountbubble: document.getElementById('cart-count-bubble'),
            dataproductform: document.getElementById('data-product-form'),
            cartcouponcodecollapsable: document.querySelector('.cart-footer-details .coupon-code'),
            cartordernotescollapsable: document.querySelector('.cart-footer-details .order-notes'),
            cartdrawerordernotes: document.getElementById('cart-drawer-order-notes'),
            cartdrawerupsell: document.getElementById('cart-drawer-upsell'),
            cartdrawercheckout: document.querySelector('#cart-drawer > .cart-footer > #checkout'),
            addtocart: document.querySelector('[data-add-to-cart]')
        }
        this.state = {
            quantity: null,
            discountcode: null,
            discountKeySubmit: false
        }
        this.load();
    }
    CartDrawer.prototype.load = async function() {
        var _ = this;
        if (_.selector.cartdrawercheckout) {
            window.addEventListener('pageshow', function (event) {
                _.selector.cartdrawercheckout.classList.remove('js-loading');
                // Audit C1 (11 Oct 2026): a page restored from the back/forward cache keeps
                // the drawer and badge it had when it was left (e.g. "cart is empty", 0,
                // after add to cart then Back). Re-read the cart and repaint both.
                if (event.persisted) _.repaintcartdrawer();
            });
        }
        if(_.selector.cartbubble) {
            _.selector.cartbubble.addEventListener('click', event => {
                event.preventDefault();
                _.selector.cartdrawer.classList.add('active');
                _.selector.cartdraweroverlay.classList.add('active');
                _.repaintcartdrawer();
                document.body.classList.add("scroll-lock");
            })
        }
        if(_.selector.cartdrawerclose) {
            _.selector.cartdrawerclose.addEventListener('click', () => {
                _.selector.cartdrawer.classList.remove('active');
                _.selector.cartdraweroverlay.classList.remove('active');
                document.body.classList.remove("scroll-lock");
            })
        }
        if(_.selector.formcartdrawer) {
            // Audit A8 (11 Oct 2026): Safari before 15.4 has no SubmitEvent.submitter, so the
            // submit handler below returned at once and plus, minus, remove and checkout did
            // nothing there. When event.submitter is undefined, fall back to the submit button
            // that was just clicked (recorded here: Safari does not focus a button on click or
            // tap, so document.activeElement alone would miss it), then to
            // document.activeElement (keyboard). Only a submit button that belongs to this
            // form is accepted; .form is used because the checkout button sits outside the
            // <form> and is tied to it by its form attribute.
            const isCartSubmitButton = element => !!element && (element.tagName === 'BUTTON' || element.tagName === 'INPUT') && element.type === 'submit' && element.form === _.selector.formcartdrawer;
            let lastSubmitClicked = null;
            (_.selector.cartdrawer || _.selector.formcartdrawer).addEventListener('click', event => {
                const clicked = event.target.closest('button, input');
                lastSubmitClicked = isCartSubmitButton(clicked) ? clicked : null;
            }, true);
            _.selector.formcartdrawer.addEventListener('submit', event => {
                event.preventDefault();
                let submitter = event.submitter;
                if (submitter === undefined) submitter = lastSubmitClicked || (isCartSubmitButton(document.activeElement) ? document.activeElement : null);
                lastSubmitClicked = null;
                if (!submitter) return;
                if(submitter.classList.contains('minus')) {
                    const control_quantity = submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity && parseInt(control_quantity.value) > 1) {
                        control_quantity.value = parseInt(control_quantity.value) - 1;
                        _.updatequantity(submitter);
                    }                   
                }        
                if(submitter.classList.contains('plus')) {
                    const control_quantity = submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity && parseInt(control_quantity.value) > 0) {
                        control_quantity.value = parseInt(control_quantity.value) + 1;
                        _.updatequantity(submitter);
                    }                   
                }           
                if(submitter.classList.contains('remove')) {
                    const control_quantity = submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity) {
                        control_quantity.value = 0;
                        _.updatequantity(submitter);
                    }                   
                } 
                if(submitter.classList.contains('remove-qty-is-one')) {
                    const control_quantity = submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity) {
                        control_quantity.value = 0;
                        _.updatequantity(submitter);
                    }       
                } 
                if(submitter.classList.contains('cart-drawer-checkout')) {
                    if(!submitter.disabled && !theme.CartTransactions.blocked()) {
                        submitter.classList.add('js-loading');
                        window.location.href = '/checkout';
                    }                   
                }       
                if(submitter.classList.contains('order-notes-submit')) {
                    submitter.classList.add("active");
                    _.updatenotes(submitter);

                }
            })
            _.selector.formcartdrawer.addEventListener("keyup", event => {
                event.preventDefault();
                if(event.target.closest("input.quantity") && !isNaN(event.target.closest("input.quantity").value)) {
                    _.updatequantity(event.target);
                }
                if(event.target.closest("textarea#cart-drawer-order-notes")) {
                    if(event.target.closest(".order-notes").querySelector(".order-notes-submit").type === "button") {
                        event.target.closest(".order-notes").querySelector(".order-notes-submit").type = "submit";
                    }                   
                } 
            })
            _.selector.formcartdrawer.addEventListener("keydown", event => {
                const input = event.target.closest('#cart-drawer-coupon');
                if (input && event.key === 'Enter') {
                    event.preventDefault();
                    const button = input.closest('.discount-code-container').querySelector('button');
                    if (input.value.trim() && button && !button.classList.contains('js-loading')) {
                        button.classList.add('active', 'js-loading');
                        _.checkoutapplydiscountcode(input.value, button);
                    }
                }
            })
            _.selector.formcartdrawer.addEventListener("click", async event => {
                const discountButton = event.target.closest('.discount-code-container > button');
                if(discountButton && !discountButton.classList.contains('js-loading') && discountButton.parentElement.querySelector('#cart-drawer-coupon').value.trim()) {
                    discountButton.classList.add("active", "js-loading");
                    _.checkoutapplydiscountcode(discountButton.parentElement.querySelector('#cart-drawer-coupon').value, discountButton);
                    _.state.discountKeySubmit = false;
                }    
                if(event.target.closest(".remove-discount")) {
                    event.target.closest("button") && event.target.closest("button").classList.add("active", "js-loading");
                    _.checkoutapplydiscountcode("remove-discount-code", event.target.closest("button"));
                }  
                if(event.target.closest(".order-notes-submit")) {
                    event.target.closest(".order-notes").querySelector("textarea").classList.remove("disabled");
                    event.target.closest(".order-notes-submit").textContent = `UPDATE NOTE`;                    
                    event.target.closest(".order-notes").querySelector("textarea").focus();
                }
                if(event.target.closest(".freegift-quick-view-modal-btn")) {
                    event.preventDefault();
                    await theme.QuickView.rendercontent(event.target.closest('.freegift-quick-view-modal-btn').dataset.productUrl); 
                }    
            })
            _.selector.formcartdrawer.addEventListener("change", event => {
                event.preventDefault();
                if(event.target.closest('select.variant-options') && event.target.closest('select.variant-options').selectedIndex > 0) {
                    event.target.closest('.variant-options-container').querySelector('button').disabled = false;      
                } 
            })
            _.selector.formcartdrawer.addEventListener("mousedown", async event => {
                if(event.target.closest(".freegift-quick-view-modal-btn")) {
                    event.preventDefault();
                }    
            })
            _.selector.formcartdrawer.addEventListener("touchstart", async event => {
                if(event.target.closest(".freegift-quick-view-modal-btn")) {
                    event.preventDefault();
                }    
            })
        }
        if(_.selector.addtocart) {
            var targetNode = _.selector.addtocart;
            var config = { attributes: true, attributeFilter: ['class'] };
            var callback = function(mutationsList, observer) {
            for(var mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if(mutation.target.className.includes('added')) {
                        _.addtocart();
                    }
                }
            }
            };
            var observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
        if(_.selector.cartdrawer) {
            _.selector.cartdrawer.addEventListener('click', async event => {  
                if(event.target.closest('.coupon-code-heading')) {
                    var lkcCoupon = event.target.closest('.coupon-code');
                    lkcCoupon.classList.toggle('active');
                    // T5.57 — On open, scroll the apply field into view so it isn't left
                    // below the fold behind the sticky footer (verified: scroll area ~460px
                    // vs ~929px content). scroll-margin-bottom (CSS) keeps a gap above it.
                    if(lkcCoupon.classList.contains('active')) {
                        var lkcCt = lkcCoupon.querySelector('.discount-code-container');
                        if(lkcCt) requestAnimationFrame(function(){ lkcCt.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
                    }
                }
                if(event.target.closest('.order-notes-heading')) {
                    var lkcNotes = event.target.closest('.order-notes');
                    lkcNotes.classList.toggle('active');
                    if(lkcNotes.classList.contains('active')) {
                        var lkcNb = lkcNotes.querySelector('.order-notes-submit');
                        if(lkcNb) requestAnimationFrame(function(){ lkcNb.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
                    }
                }
                if(event.target.closest('.freegift-add-to-cart')) {
                    const selectedOption = event.target.closest('.variant-options-container').querySelector('select');
                    if(selectedOption) {
                        event.target.closest('.freegift-add-to-cart').disabled = true;
                        await _.addfreegift(selectedOption.options[selectedOption.selectedIndex].value);
                        event.target.closest('.freegift-add-to-cart').disabled = false;
                    }              
                }    
            })
        }
        if(_.selector.cartdraweroverlay) {
            _.selector.cartdraweroverlay.addEventListener('click', event => {
                event.preventDefault();
                _.selector.cartdrawer.classList.remove('active');
                _.selector.cartdraweroverlay.classList.remove('active');
                document.body.classList.remove("scroll-lock");
            })
        }
        if(_.selector.cartbubble) {
            if(window.location.pathname === '/cart') {
            
                await theme.PromotionalProgressbar.recalculate();
                document.body.classList.add("scroll-lock");
                _.selector.cartdrawer.classList.add('active');
                _.selector.cartdraweroverlay.classList.add('active');
            }
        }
    }
    CartDrawer.prototype.updatequantity = async function(submitter) {
        const control = submitter.closest('.quantity-control')?.querySelector('.quantity');
        if (!control) return;
        const original = Number(control.defaultValue);
        const requested = Number(control.value);
        const captured = theme.CartTransactions.snapshot(control);
        const answer = await theme.CartTransactions.quantity(control.dataset.itemKey, requested, captured);
        const refreshed = await theme.CartTransactions.render(answer, { open: false });
        if (!refreshed && control.isConnected) {
            const deleted = requested === 0 && ['success', 'recovered'].includes(answer.status);
            if (deleted) {
                const row = control.closest('.item');
                if (row) row.remove();
                else {
                    control.disabled = true;
                    control.closest('.quantity-control')?.querySelectorAll('button').forEach(button => { button.disabled = true; });
                }
            }
            const candidates = answer.cart?.items?.filter(item => captured && theme.CartTransactions.identity(item) === theme.CartTransactions.identity(captured)) || [];
            const confirmed = !deleted && (answer.cart?.items?.find(item => item.key === control.dataset.itemKey) || (candidates.length === 1 ? candidates[0] : null));
            const count = confirmed ? Number(confirmed.quantity) : original;
            control.value = count;
            control.defaultValue = count;
            if (confirmed) {
                control.dataset.itemKey = confirmed.key;
                control.dataset.cartLine = JSON.stringify(confirmed);
            }
        }
        if (requested === 0 && ['success', 'recovered'].includes(answer.status) && submitter.classList.contains('free-gift')) {
            // Audit G4 (11 Oct 2026): the new progress bar remembers the removed gift by
            // product ID and keeps it in sessionStorage (rememberDeletedFreeGift, in
            // component-promotional-progress-bar-new.js). The old push stays as the fallback
            // for the legacy progress bar script, which has no such method.
            if (typeof theme.PromotionalProgressbar.rememberDeletedFreeGift === 'function') {
                theme.PromotionalProgressbar.rememberDeletedFreeGift(control.dataset.itemId);
            } else {
                theme.PromotionalProgressbar.state.deletedFreeGift.push(control.dataset.itemId);
            }
        }
    }
    CartDrawer.prototype.updatenotes = async function(submitter) {
        const field = document.getElementById('cart-drawer-order-notes');
        const answer = await theme.CartTransactions.update({ note: field?.value || '' });
        await theme.CartTransactions.render(answer, { open: false });
        submitter.classList.remove('active');
    }
    CartDrawer.prototype.addtocart = async function() {
        const answer = await theme.CartTransactions.refresh();
        await theme.CartTransactions.render(answer);
    }
    CartDrawer.prototype.checkoutapplydiscountcode = async function(code, target) {
        this.state.discountcode = code;
        const removing = code === 'remove-discount-code';
        try {
            const answer = await theme.CartTransactions.update({ discount: removing ? '' : code });
            const refreshed = await theme.CartTransactions.render(answer, { open: false });
            if (refreshed && ['success', 'recovered'].includes(answer.status)) {
                const container = document.getElementById('cart-drawer-coupon-code');
                container?.classList.add('active');
                const applied = theme.CartTransactions.discountApplied(answer.cart, code);
                const notification = document.getElementById(removing ? 'cart-drawer-remove-notification' : (applied ? 'cart-drawer-success-notification' : 'cart-drawer-error-notification'));
                notification?.classList.add('active');
                setTimeout(() => notification?.classList.remove('active'), 5000);
            }
        } finally {
            target?.classList.remove('active', 'js-loading');
            this.state.discountKeySubmit = false;
        }
    }
    CartDrawer.prototype.repaintcartdrawer = async function() {
        const answer = await theme.CartTransactions.refresh();
        await theme.CartTransactions.render(answer, { open: false });
    }
    CartDrawer.prototype.addfreegift = async function(id) {
        const answer = await theme.CartTransactions.add({ id, quantity: 1 }, { onlyIfMissing: true });
        await theme.CartTransactions.render(answer);
        return answer;
    }
    theme.CartDrawer = new CartDrawer;
}
theme.CartDrawer();
